export const CUSTOMS_DECLARATIONS_VALIDATE_CUSTOMS_AND_SAVE = 'CUSTOMS_DECLARATIONS_VALIDATE_CUSTOMS_AND_SAVE';

export const validateCustomsAndSave = (fulfillmentPlanId, customs, needsCustoms) => ({
  type: CUSTOMS_DECLARATIONS_VALIDATE_CUSTOMS_AND_SAVE,
  fulfillmentPlanId,
  customs,
  needsCustoms,
});
